import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { from, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { switchMap, tap } from "rxjs/operators";
import { MsalService } from "@azure/msal-angular";
import { EventType, SilentRequest } from "@azure/msal-browser";

@Injectable({
  providedIn: "root",
})
export class AuthInterceptorService implements HttpInterceptor {
  isLoggedIn = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private msalService: MsalService
  ) {
    this.msalService.instance.addEventCallback(async (event: any) => {
      if (
        event.eventType === EventType.SSO_SILENT_FAILURE ||
        event.eventType === EventType.ACQUIRE_TOKEN_FAILURE ||
        event.eventType === EventType.ACQUIRE_TOKEN_BY_CODE_FAILURE
      ) {
        // Don't attempt re-login if currently on maintenance page (downtime active)
        if (this.router.url !== '/Maintenance') {
          await this.authService.logIn();
        }
      }
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let headers = req.headers;
    let externalLinkToken = null;
    let externalFlag = true;
    if (headers.has("externalLinkToken")) {
      externalFlag = false;
      externalLinkToken = headers.get("externalLinkToken");
    }

    const requestPermissionScope: SilentRequest = {
      scopes: [environment.scopesUserRead],
      forceRefresh: true,
      account: externalFlag ? this.msalService.instance.getActiveAccount() ?? undefined : undefined,
    };

    if (environment.oauth) {
      if (externalFlag) {
        return from(
          this.msalService.instance.acquireTokenSilent(requestPermissionScope)
        ).pipe(
          switchMap((token) => {
            const authHeaders = req.headers.set(
              "Authorization",
              `Bearer ${token.idToken}`
            );
            const authReq = req.clone({ headers: authHeaders });
            return next.handle(authReq).pipe(
              tap(
                (_) => { },
                (error) => {
                  const respError = error as HttpErrorResponse;
                  if (this.shouldNavigateUnauthorized(respError, req.url)) {
                    this.router.navigate(["/Unauthorized"]);
                  }
                  else if (respError && respError.status === 503) {
                    this.router.navigate(["/Maintenance"]);
                  }
                }
              )
            );
          })
        );
      }
      else {
        const authReq = req.clone({ headers });
        return next.handle(authReq)
          .pipe(
            tap(
              (_) => { },
              (error) => {
                const respError = error as HttpErrorResponse;
                if (this.shouldNavigateUnauthorized(respError, req.url)) {
                  this.router.navigate(["/Unauthorized"]);
                }
                else if (respError && respError.status === 503) {
                  this.router.navigate(["/Maintenance"]);
                }
              }
            )
          );
        //  .toPromise();
      }
    }

    return next.handle(req);
  }

  private shouldNavigateUnauthorized(respError: HttpErrorResponse, requestUrl: string): boolean {
    if (!respError) {
      return false;
    }

    if (respError.status === 401) {
      return true;
    }

    // Only treat 403/404 as Unauthorized during identity bootstrap.
    if ((respError.status === 403 || respError.status === 404) && requestUrl.includes('/User/GetCurrentUser')) {
      return true;
    }

    return false;
  }
}
